import script from "./MessageComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageComponent.vue?vue&type=script&setup=true&lang=js"

import "./MessageComponent.vue?vue&type=style&index=0&id=2910fc9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2910fc9f"]])

export default __exports__